import { useEffect, useState } from 'react';
import { TextField, InputAdornment } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import { useTheme } from '@mui/material/styles';
import { debounce } from '@mui/material/utils';

interface SearchInputProps {
  onSearch: (value: string) => void;
  placeholder: string;
}

export const SearchInput = ({ onSearch, placeholder }: SearchInputProps) => {
  const theme = useTheme();
  const [searchValue, setSearchValue] = useState('');

  const debouncedSearch = debounce(onSearch, 300);

  useEffect(() => {
    debouncedSearch(searchValue);

    return () => {
      debouncedSearch.clear();
    };
  }, [searchValue]);

  return (
    <TextField
      variant="outlined"
      placeholder={placeholder}
      onChange={(e) => setSearchValue(e.target.value)}
      InputProps={{
        startAdornment: (
          <InputAdornment position="start">
            <SearchIcon />
          </InputAdornment>
        ),
      }}
      sx={{
        backgroundColor: theme.palette.primaryAlternative.lighter,
        width: '100%',
        maxWidth: theme.spacing(40),
        '& input': {
          padding: `${theme.spacing(1)} ${theme.spacing(1.5)} ${theme.spacing(1)} 0`,
        },
      }}
    />
  );
};
